import React, { useEffect, useState } from "react";
import { Modal, Button, Card, List, Space, Typography, Pagination, Input, AutoComplete, message, Tag } from "antd";
import axios from '../../services/axios';
import moment from "moment";

const { Title } = Typography;

const ViewProject = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [projects, setProjects] = useState([]);

  const user = localStorage.getItem('user');
  const pageSize = 8;

  const handleViewProject = (project) => {
    setSelectedProject(project);
    setIsModalVisible(true);
  };

  const handleCloseModal = () => {
    setSelectedProject(null);
    setIsModalVisible(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getAllProjects = async() => {
		try {
			const res = await axios.post('get-user-projects', { user });
			if (res && res.data && res.data.projects && res.data.projects.length) {
				setProjects(res.data.projects);
			}
		} catch (err) {
			if (err.response && err.response.data && err.response.data.msg) {
				message.warning(err.response.data.msg);
			} else if (err.response && err.response.data && err.response.data.userName) {
				message.warning(err.response.data.userName[0]);
			} else if (err.response && err.response.status === 401) {
				message.error('User not authorised');
			} else {
				message.error('Something went wrong');
			}
		}
	};

  useEffect(()=> {
    getAllProjects();
  }, []);

  const filteredProjects = projects?.filter((project) =>
    project.projectName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedProjects = filteredProjects.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div className="relative flex-1 p-10 overflow-y-auto ml-7 mr-2 min-h-screen">
      {/* Header Section */}
      <div
        style={{
          marginBottom: "40px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* <Title level={2} style={{ margin: 0, color: "#1a1a1a" }}>View Projects</Title> */}
        <AutoComplete
          style={{ width: "300px" }}
          options={projects.map((project) => ({ value: project.projectName }))}
          filterOption={(inputValue, option) =>
            option.value.toLowerCase().includes(inputValue.toLowerCase())
          }
          onSelect={(value) => setSearchTerm(value)}
        >
        <Input.Search
          placeholder="Search by project name"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          size="large"
        />
        </AutoComplete>
      </div>

      {/* Project Cards Grid */}
      <List
          grid={{
            gutter: [16, 16],
            xs: 1,
            sm: 2,
            md: 3,
            lg: 4,
            xl: 4,
            xxl: 4,
          }}
          dataSource={paginatedProjects}
          renderItem={(project) => (
            <List.Item>
              <Card
                className="rounded-xl shadow-md transition duration-300 hover:shadow-2xl"
                style={{ minHeight: "260px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}
              >
                <div className="mb-2">
                  <Title level={4} style={{ marginBottom: "10px", color: "#333" }}>
                    {project.projectName}
                  </Title>
                  <p style={{ color: "#555", fontSize: "14px" }}>
                    <strong>Code:</strong> {project.projectCode}
                  </p>
                  <p style={{ fontSize: "13px", color: "#666" }}>
                    {project.projectDescription.substring(0, 60)}...
                  </p>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                  <Tag color={project.active ? "green" : "red"}>
                    {project.active ? "Active" : "Inactive"}
                  </Tag>
                  <Button type="primary" size="small" onClick={() => handleViewProject(project)}>
                    View Details
                  </Button>
                </div>
              </Card>
            </List.Item>
          )}
        />


      {/* Pagination */}
      <div className='flex justify-end' style={{ marginTop: "40px", textAlign: "center" }}>
        <Pagination
          current={currentPage}
          pageSize={pageSize}
          total={filteredProjects.length}
          onChange={handlePageChange}
        />
      </div>

      {/* Project Details Modal */}
      <Modal
        title="Project Details"
        open={isModalVisible}
        onCancel={handleCloseModal}
        destroyOnClose={true}
        footer={[
          <Button key="close" onClick={handleCloseModal} style={{ backgroundColor: "red", color: "white", border: "none", cursor: 'pointer'}}>
            Close
          </Button>,
        ]}
        width={600}
      >
        {selectedProject && (
          <Card>
            <div style={{ 
              maxHeight: "300px", 
              overflowY: "auto", 
              paddingRight: "10px"  
            }}>
              <Space direction="vertical" size="middle" style={{ width: "100%" }}>
                <p><strong>Project Name:</strong> {selectedProject.projectName}</p>
                <p><strong>Project Code:</strong> {selectedProject.projectCode}</p>
                <p><strong>Description:</strong> {selectedProject.projectDescription}</p>
                <p><strong>Project Manager:</strong> {selectedProject.projectManager}</p>
                <p><strong>Job No:</strong> {selectedProject.jobNo}</p>
                <p><strong>Contract Form:</strong> {selectedProject.contractForm}</p>
                <p><strong>Client:</strong> {selectedProject.client}</p>
                <p><strong>Engineer:</strong> {selectedProject.engineer}</p>
                <p><strong>Location:</strong> {selectedProject.location}</p>
                <p><strong>contractRef:</strong> {selectedProject.contractRef}</p>
                <p><strong>Type:</strong> {selectedProject.type}</p>
                <p><strong>Design Consultant:</strong> {selectedProject.designConsultant}</p>
                <p><strong>Project Management:</strong> {selectedProject.projectManager}</p>
                <p><strong>Time Granted:</strong> {selectedProject.timeGranted}</p>
                <p><strong>Start Date:</strong> {selectedProject.startDate ? moment(selectedProject.startDate).format('DD/MM/YYYY') : 'NA'}</p>
                <p><strong>End Date:</strong> {selectedProject.endDate ? moment(selectedProject.endDate).format('DD/MM/YYYY') : 'NA'}</p>
              </Space>
            </div>
          </Card>
        )}
      </Modal>

    </div>
  );
};

export default ViewProject;
